import { Component, input } from '@angular/core';
import { ChipComponent } from 'common/designsystem/chip/chip.component';
import { TranslateModule } from '@ngx-translate/core';
import { MatTooltip } from '@angular/material/tooltip';
import { ApiIntakeType } from 'api';

@Component({
  selector: 'comp-intake-type-chip',
  templateUrl: './intake-type-chip.component.html',
  imports: [ChipComponent, TranslateModule, MatTooltip],
})
export class IntakeTypeChipComponent {
  showDot = input<boolean>();
  intakeType = input.required<ApiIntakeType>();
}
